export const loadingAnimation = {
  "v": "5.12.1",
  "fr": 29.9700012207031,
  "ip": 0,
  "op": 66.0000026882351,
  "w": 1000,
  "h": 1000,
  "nm": "Straight Line Loader",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Layer 24/Greenlight-logo-layers Outlines 34",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.2, "y": 1 },
              "o": { "x": 0.8, "y": 0 },
              "t": 0,
              "s": [270.359, 499.75, 0],
              "to": [76.477, -0.023, 0],
              "ti": [-76.477, 0.023, 0]
            },
            {
              "i": { "x": 0.2, "y": 0.2 },
              "o": { "x": 0.8, "y": 0.8 },
              "t": 17.059,
              "s": [729.219, 499.609, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.2, "y": 1 },
              "o": { "x": 0.8, "y": 0 },
              "t": 33,
              "s": [729.219, 499.609, 0],
              "to": [-76.477, 0.023, 0],
              "ti": [76.477, -0.023, 0]
            },
            { "t": 50.0587520389347, "s": [270.359, 499.75, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [2232.831, 943.687, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [152, 152, 100], "ix": 6, "l": 2 }
      },
      "ao": 1,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [11.891, 0],
                    [0, 0],
                    [0, -12.364],
                    [0, 0],
                    [-11.893, 0],
                    [0, 0],
                    [0, 12.364],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-11.893, 0],
                    [0, 0],
                    [0, 12.364],
                    [0, 0],
                    [11.891, 0],
                    [0, 0],
                    [0, -12.364]
                  ],
                  "v": [
                    [9.574, -33.648],
                    [-9.575, -33.648],
                    [-31.545, -12.972],
                    [-31.545, 13.581],
                    [-9.575, 33.648],
                    [9.574, 33.648],
                    [31.545, 13.581],
                    [31.545, -12.972]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0, 0.850980392157, 0.705882352941, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [2232.831, 943.687], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 259.000010549286,
      "st": -41.0000016699642,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Layer 24/Greenlight-logo-layers Outlines 37",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.2, "y": 1 },
              "o": { "x": 0.8, "y": 0 },
              "t": 4.411,
              "s": [270.359, 499.75, 0],
              "to": [76.477, -0.023, 0],
              "ti": [-76.477, 0.023, 0]
            },
            {
              "i": { "x": 0.2, "y": 0.2 },
              "o": { "x": 0.8, "y": 0.8 },
              "t": 21.47,
              "s": [729.219, 499.609, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.2, "y": 1 },
              "o": { "x": 0.8, "y": 0 },
              "t": 37.411,
              "s": [729.219, 499.609, 0],
              "to": [-76.477, 0.023, 0],
              "ti": [76.477, -0.023, 0]
            },
            { "t": 54.4700022186086, "s": [270.359, 499.75, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [2232.831, 943.687, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [152, 152, 100], "ix": 6, "l": 2 }
      },
      "ao": 1,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [11.891, 0],
                    [0, 0],
                    [0, -12.364],
                    [0, 0],
                    [-11.893, 0],
                    [0, 0],
                    [0, 12.364],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-11.893, 0],
                    [0, 0],
                    [0, 12.364],
                    [0, 0],
                    [11.891, 0],
                    [0, 0],
                    [0, -12.364]
                  ],
                  "v": [
                    [9.574, -33.648],
                    [-9.575, -33.648],
                    [-31.545, -12.972],
                    [-31.545, 13.581],
                    [-9.575, 33.648],
                    [9.574, 33.648],
                    [31.545, 13.581],
                    [31.545, -12.972]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.580392156863, 0.274509803922, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [2232.831, 943.687], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 3.00000012219251,
      "op": 74.0000030140818,
      "st": -35.0000014255792,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Layer 24/Greenlight-logo-layers Outlines 36",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.2, "y": 1 },
              "o": { "x": 0.8, "y": 0 },
              "t": 8.824,
              "s": [270.359, 499.75, 0],
              "to": [76.477, -0.023, 0],
              "ti": [-76.477, 0.023, 0]
            },
            {
              "i": { "x": 0.2, "y": 0.2 },
              "o": { "x": 0.8, "y": 0.8 },
              "t": 25.883,
              "s": [729.219, 499.609, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.2, "y": 1 },
              "o": { "x": 0.8, "y": 0 },
              "t": 41.824,
              "s": [729.219, 499.609, 0],
              "to": [-76.477, 0.023, 0],
              "ti": [76.477, -0.023, 0]
            },
            { "t": 58.8825023983334, "s": [270.359, 499.75, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [2232.831, 943.687, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [152, 152, 100], "ix": 6, "l": 2 }
      },
      "ao": 1,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [11.891, 0],
                    [0, 0],
                    [0, -12.364],
                    [0, 0],
                    [-11.893, 0],
                    [0, 0],
                    [0, 12.364],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-11.893, 0],
                    [0, 0],
                    [0, 12.364],
                    [0, 0],
                    [11.891, 0],
                    [0, 0],
                    [0, -12.364]
                  ],
                  "v": [
                    [9.574, -33.648],
                    [-9.575, -33.648],
                    [-31.545, -12.972],
                    [-31.545, 13.581],
                    [-9.575, 33.648],
                    [9.574, 33.648],
                    [31.545, 13.581],
                    [31.545, -12.972]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.803921628466, 0.878431432387, 0.070588235294, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [2232.831, 943.687], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 6.00000024438501,
      "op": 80.0000032584668,
      "st": -29.0000011811942,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Layer 24/Greenlight-logo-layers Outlines 35",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.2, "y": 1 },
              "o": { "x": 0.8, "y": 0 },
              "t": 13.235,
              "s": [270.359, 499.75, 0],
              "to": [76.477, -0.023, 0],
              "ti": [-76.477, 0.023, 0]
            },
            {
              "i": { "x": 0.2, "y": 0.2 },
              "o": { "x": 0.8, "y": 0.8 },
              "t": 30.294,
              "s": [729.219, 499.609, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.2, "y": 1 },
              "o": { "x": 0.8, "y": 0 },
              "t": 46.235,
              "s": [729.219, 499.609, 0],
              "to": [-76.477, 0.023, 0],
              "ti": [76.477, -0.023, 0]
            },
            { "t": 63.2937525780073, "s": [270.359, 499.75, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [2232.831, 943.687, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [152, 152, 100], "ix": 6, "l": 2 }
      },
      "ao": 1,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [11.891, 0],
                    [0, 0],
                    [0, -12.364],
                    [0, 0],
                    [-11.893, 0],
                    [0, 0],
                    [0, 12.364],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-11.893, 0],
                    [0, 0],
                    [0, 12.364],
                    [0, 0],
                    [11.891, 0],
                    [0, 0],
                    [0, -12.364]
                  ],
                  "v": [
                    [9.574, -33.648],
                    [-9.575, -33.648],
                    [-31.545, -12.972],
                    [-31.545, 13.581],
                    [-9.575, 33.648],
                    [9.574, 33.648],
                    [31.545, 13.581],
                    [31.545, -12.972]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.541176470588, 0.713725490196, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [2232.831, 943.687], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 9.00000036657752,
      "op": 86.0000035028518,
      "st": -23.0000009368092,
      "ct": 1,
      "bm": 0
    }
  ],
  "markers": [],
  "props": {}
}
